import { ResumeService } from './../../services/resume.service';
import { AboutService } from './../../services/about.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.css']
})
export class ResumeComponent implements OnInit {

  titular: any;
  resume: any;
  experiencias: any[];

  constructor(private aboutService: AboutService,
              private resumeService: ResumeService) {

    this.titular = aboutService.titular;
    // console.log(this.titular);
    this.resume = resumeService.resume;
    this.experiencias = resumeService.experiencias;

  }



  ngOnInit(): void {
  }

}
